"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileDescriptor = void 0;
/**
 * FileDescriptor
 * @doc FileDescriptor
 */
var FileDescriptor = /** @class */ (function () {
    function FileDescriptor(data) {
        /**
         * @description a system assigned unique id
         */
        this.id = '';
        /**
         * @description the file content hash (null for folders)
         */
        this.hash = null;
        /**
         * @description the file location
         */
        this.path = '';
        /**
         * @description the file mime type
         */
        this.mimeType = null;
        /**
         * @description file or directory
         */
        this.type = null;
        /**
         * @description the file size (content-length) in bytes, null for folders
         */
        this.size = undefined;
        /**
         * @description whether the file has public access or not
         */
        this.acl = null;
        /**
         * @description bucket - bucket name
         */
        this.bucket = null;
        /**
         * @description lifecycle - delete action: how long the file should leave in seconds
         */
        this.lifecycle = null;
        this.dateCreated = null;
        /**
         * @description dateExpired - date and time when file will be removed
         */
        this.dateExpired = null;
        this.dateUpdated = null;
        this.acl = data.acl || null;
        this.bucket = data.bucket || null;
        this.dateCreated = data.dateCreated || null;
        if (data.dateCreated && data.lifecycle) {
            this.dateExpired = new Date(new Date(data.dateCreated).getTime() + data.lifecycle.age * 1000).toISOString();
        }
        this.dateUpdated = data.dateUpdated || null;
        if (data.id) {
            this.id = data.id;
        }
        this.hash = data.hash || null;
        this.lifecycle = data.lifecycle || null;
        this.mimeType = data.mimeType || null;
        if (data.path) {
            this.path = data.path;
        }
        if (data.size !== undefined) {
            this.size = data.size;
        }
        this.type = data.type || null;
    }
    return FileDescriptor;
}());
exports.FileDescriptor = FileDescriptor;
//# sourceMappingURL=file-descriptor.js.map